import { Mapper } from "planning-portal-library/src/lib/core/base";
import { PlanLocationGroupWebEntity } from "./plan-location-group-web-entity";
import { PlanLocationGroup } from "planning-portal-library/src/lib/core/domain/models/plan-location-group";

export class PlanLocationGroupWebRepositoryMapper extends Mapper<
  PlanLocationGroupWebEntity,
  PlanLocationGroup
> {
  mapFrom(param: PlanLocationGroupWebEntity): PlanLocationGroup { 
    return {
      planId: param.planId,
      locationGroupId: param.locationGroupId,      
    };
  }

  mapTo(param: PlanLocationGroup): PlanLocationGroupWebEntity {    
    return {
      planId: param.planId,
      locationGroupId: param.locationGroupId,
      
    };
  }
}